import { fmtDateTime } from '../../../shared/format';
import { Badge, Card, Empty, ErrorBox, Loading, useAsync } from '../../../shared/ui';
import { api, tenantPath } from '../../api';
import { OUTBOX_LABELS, OUTBOX_TONES, mailKindLabel } from '../../labels';
import type { OutboxMessage } from '../../types';
import type { TenantTabProps } from '../TenantDetail';

export function OutboxTab({ slug }: TenantTabProps): JSX.Element {
  const outbox = useAsync(() => api.get<{ messages: OutboxMessage[] }>(`${tenantPath(slug)}/outbox`).then((r) => r.messages), [slug]);
  return (
    <Card
      bodyless
      title={
        <div>
          <h2>Avisos por correo</h2>
          <p className="subtle">Los últimos 100 correos de este cliente. Los fallidos se reintentan solos; el error dice por qué.</p>
        </div>
      }
      actions={
        <button className="btn" onClick={() => void outbox.reload()} disabled={outbox.loading}>
          {outbox.loading ? 'Cargando…' : 'Actualizar'}
        </button>
      }
    >
      {outbox.loading && !outbox.data ? (
        <Loading />
      ) : outbox.error ? (
        <div className="card-body">
          <ErrorBox error={outbox.error} onRetry={() => void outbox.reload()} />
        </div>
      ) : !outbox.data?.length ? (
        <Empty icon="✉">
          <p>Todavía no se ha mandado ningún aviso.</p>
          <p className="subtle">Aparecerán aquí cuando el repaso de SAP publique pedidos o alguien proponga fechas o precios.</p>
        </Empty>
      ) : (
        <div className="table-wrap">
          <table className="table">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Tipo</th>
                <th>Para</th>
                <th>Asunto</th>
                <th>Estado</th>
                <th className="num">Intentos</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody>
              {outbox.data.map((m) => (
                <tr key={m.id}>
                  <td className="nowrap num">{fmtDateTime(m.createdAt)}</td>
                  <td className="nowrap" title={m.kind}>
                    {mailKindLabel(m.kind)}
                  </td>
                  <td className="break">{Array.isArray(m.to) ? m.to.join(', ') : m.to}</td>
                  <td>{m.subject}</td>
                  <td>
                    <Badge tone={OUTBOX_TONES[m.status] ?? 'neutral'}>{OUTBOX_LABELS[m.status] ?? m.status}</Badge>
                    {m.sentAt ? <div className="subtle cell-note">{fmtDateTime(m.sentAt)}</div> : null}
                  </td>
                  <td className="num">{m.attempts}</td>
                  <td className="error-cell">{m.lastError ?? <span className="subtle">—</span>}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </Card>
  );
}
